import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import moment from 'moment'
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from "../../environments/environment";



@Component({
  selector: 'app-add-banner-ads',
  templateUrl: './add-banner-ads.component.html',
  styleUrls: ['./add-banner-ads.component.css']
})
export class AddBannerAdsComponent implements OnInit {
  @Input() googleAdressType: any;
  @ViewChild("addresstextNew") addresstextNew: any;

  today: string = moment().format('D MMM YYYY');
  allPlans: Array<any> = [];
  bannerSizePlans: Array<any> = [];
  user: any;
  userSubs: any;
  planExpire: any
  loading = false;
  step = 1;
  imageUrl:any
  selectBannerPlan: string;
  selectBannerSizePlan: string;
  isCountry: boolean;
  isRegional: boolean;
  isState: boolean;
  isGlobal: boolean;
  isLocation:boolean = true;
  isArea: boolean;
  isPlan:any
  buttonText:any
  show: boolean;
  selectedSubscriptionPlan: any;
  bannerForm!: FormGroup;
  formattedaddress = " ";
  milesArray = [
    {
      id: 1,
      miles: 5,
      type: 'miles'
    },
    {
      id: 2,
      miles: 10,
      type: 'miles'
    },
    {
      id: 3,
      miles: 20,
      type: 'miles'
    },
    {
      id: 4,
      miles: 35,
      type: 'miles'
    }
    , {
      id: 5,
      miles: 50,
      type: 'miles'
    },
     {
      id: 6,
      miles: 100,
      type: 'miles'
    }
  ];

  bussinessList: any;
  address: { address: any; city: any; state: any; postalCode: any; country: any; location: { type: string; coordinates: any; }; };
  image: any;
  businessCategory: any;
  isValidDimension: boolean = false;
  isDiscount:any
  planDetail:any;
  bannerDetail:any;
  label:any;
  minWidth = 0;
  minHeight = 300;
  maxWidth = 0;
  bannerId:any;
  planName:any
  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private ngxService: NgxUiLoaderService
  ) {

   }

  ngOnInit(): void {
    console.log("ti=hisjssbsmfb  dfgkhfgng ", this.isDiscount)
    this.planDetail = JSON.parse(localStorage.getItem('planDetail'));
    this.buttonText = "Save & Next"
    this.route.queryParams.subscribe((params: any) => {
      this.isDiscount = params.isDiscount
      this.planName = params.label
      this.locationLabel(this.planName)
      if(params.isPlan) {
        this.isPlan = params.isPlan,

        this.buttonText = "Save"
        this.getBannerDetail()
      }
      if (params.id) {
        this.bannerId = params.id;
        this.buttonText = "Update"
        this.getBannerAd(this.bannerId)
      } else {
        this.checkBannerSize(this.planDetail.bannerSize)
      }
    })

    this.subscriptionPlans();
    this.businessList("");
    this.getUserProfile();
    this.categoryList();

    this.bannerForm = this.formBuilder.group({
      bannerCategory: ['', Validators.required],
      image: [''],
      location: [''],
      radius: [''],
      url : []
    });

    if (this.user?.bannerPlanType[0]?.caption === 'Regional') {
      this.bannerForm.controls['radius'].setValidators(Validators.required);
    }

  }
  locationLabel(type:any) {
    if(type == 'Global') this.label = "Global Visibility"
    else if(type == 'Country') this.label = "Select Country"
    else if(type == 'State/Province') this.label = "Select State/Province"
    else if(type == 'Regional') this.label = "Select ZIP/Postal Code"
  }
  subscriptionPlans(): void {
    this.spinner.show();
    this.authenticationService.getBannerPlans().subscribe(
      (response: any) => {
        let bannerPlans = response?.data.filter((data) => data.type != "bannerSize");
        let bannerSizePlans = response?.data.filter((data) => data.type == "bannerSize");
        this.bannerSizePlans = bannerSizePlans;
        this.allPlans = bannerPlans;
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }

  redirect() {
    this.router.navigate(['/dashboard']);
  }

  clickcancel(id, i) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Your subscription/advertisement will be immediately removed without a refund and will not renew. If you decide to re-subscribe or create a new advertisement, it will be a current pricing. Do you still want to cancel?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Cancel Subscription',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authenticationService.cancelCommonMerchantSubscription({ id }).subscribe(
          (response: any) => {
            // this.subscriptionResult?.splice(i, 1);
            Swal.fire(
              'Cancel!',
              'Your Subscription has been Canceled.',
              'success'
            );
            this.userSubs = [];
          },
          (error) => {
            console.log('error', error);
          }
        );
      }
    });
  }

  selectType(val) {
    this.show = false
    this.loading = true
    if (val) {
      setTimeout(() => {
        this.show = true
        this.loading = false
      }, 1500)
    }

    if (val == 1) {
      this.isArea = true;

    } else if (val == 2) {
      this.isArea = false;

    }

  }

  public businessList(search:any): void {
    this.authenticationService.getBusinessType(search).subscribe(
      (data: any) => {
        this.bussinessList = data['items'];

      },
      (error) => {
        console.error(error);
      }
    );
  }

  public categoryList(): void {
    this.authenticationService.getBannerCategory().subscribe(
      (data: any) => {
        let arr = data['data'];
        this.businessCategory = arr;
        if(this.businessCategory) {
          this.getBannerDetail();
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  addressChange() {
    if (!this.addresstextNew) {
      return
    }
    setTimeout(() => this.getGoogleAddress(this.addresstextNew))
    this.isLocation = true;
  }

  getGoogleAddress(address: any) {
    let addressData: any = [];
    const autocomplete = new google.maps.places.Autocomplete(
      address?.nativeElement,
      {
        types: [this.googleAdressType],
      }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {

      const place: any = autocomplete?.getPlace();
      if (place) {

        place.address_components.find((data: any) => {
          if (data.types.includes('postal_code')) {
            addressData.zipCode = data.long_name
          }
          if (data.types.includes("country")) {
            addressData.country = data.long_name
          }
          if (data.types.includes("administrative_area_level_1")) {
            addressData.state = data.long_name
          }
          if (data.types.includes("locality")) {
            addressData.city = data.long_name
          }
        }
        );

        addressData.formattedAddress = place.formatted_address;
        addressData.name = place.name;
        let arr = place?.formatted_address?.split(',');
        let lat = place?.geometry?.location.lat();
        let lng = place?.geometry?.location.lng();
        addressData.coordinate = [lat, lng];
        let addressValue = {
          address: addressData.name ? addressData.name : '',
          city: addressData.city ? addressData.city : '',
          state: addressData.state ? addressData.state : '',
          postalCode: addressData.zipCode ? addressData.zipCode : '',
          country: addressData.country ? addressData.country : '',
          location: {
            type: 'Point',
            coordinates: addressData.coordinate ? addressData.coordinate : ''
          },
        }
        this.address = addressValue;
      }
    });

    console.log("addressData", addressData)

    return addressData;
  }

  getUserProfile(): void {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.user = response.data;
        let url = environment.merchantProfileUrl+'/'+this.user.businessUserName
        this.bannerForm.patchValue({
          url: url
        });
        console.log(this.user, 'testing')
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  readUrl(event: any) {
    this.imageUrl = "";
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      const file = event.target.files[0];
      let fileSize = file.size / (1024 * 1024)
      if(fileSize > 25) {
        Swal.fire({
          titleText: `File size should not exceed 25 MB. Please choose a smaller file.`,
          icon: 'error'
        });
        event.target.value = '';
        return false
      }
      reader.onload = (e: any) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const width = img.width;
          const height = img.height;
     if (
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/jpg' ||
            file.type === 'image/webp'
          ) {
            if (width == this.minWidth  && height == this.minHeight) {
              this.isValidDimension = true
              this.imageUrl = e.target.result;
              this.onFileSelect(event);
            } else {
              this.bannerForm.controls['image'].setValue('');
              Swal.fire({
                titleText: `Invalid image dimensions (should be  ${this.maxWidth}x${this.minHeight})`,
                icon: 'error'
              });
              event.target.value = '';
            }
          } else {
            this.bannerForm.controls['image'].setValue('');
            Swal.fire({
              titleText: `Invalid image type`,
              icon: 'error'
            });
            event.target.value = '';
          }
        };
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }


  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file: File = event.target.files[0];
      const formData = new FormData();
      formData.append("image", file);
      formData.append("imageType", 'image');
      this.ngxService.start();
      this.authenticationService.upload(formData).subscribe(
        (data: any) => {
          this.image = data?.data?.url;
          this.imageUrl = environment.basePath + data?.data?.url;
          if(data.data && data.data.url) {
            this.bannerForm.patchValue(this.image);
          } else {
            this.bannerForm.get('image').setValue('');
          }
          // this.bannerForm.controls['image'].setValue(this.image);
          this.ngxService.stop();
        },
        (error) => {
          this.bannerForm.get('image').setValue("");
          Swal.fire('Oops...', error.error.message, 'error');
          this.ngxService.stop();
        }
      );
    } else {
      Swal.fire('error', 'Oops...', 'error');
    }
  }

  getBannerAd(id:any): void {
    this.authenticationService.getBannerAd(id).subscribe(
      (response: any) => {
        this.bannerDetail = response?.data;
        console.log(response?.data?.image, 'response?.data')
        this.imageUrl = environment.basePath + response?.data.image;
        this.isValidDimension = true
        this.image = response?.data.image;
        let city = response?.data?.address?.city ? response?.data?.address?.city+ ',': '';
        let state = response?.data?.address?.state ? response?.data?.address?.state+ ',': '';
        let country = response?.data?.address?.country ? response?.data?.address?.country + ',': '';
        let postalCode = response?.data?.address?.postalCode ? response?.data?.address?.postalCode: '';
        this.address = response?.data?.address;
        this.bannerForm.patchValue({
          bannerCategory: response?.data?.bannerCategory,
          url: response?.data.url,
          location:city+ state+country+postalCode,
          radius: response?.data.radius
        });

       if(this.bannerId) this.checkBannerSize(response?.data?.offerBannerSize)
      },
      error => {
        this.spinner.hide();

      }
    );
  }
  checkBannerSize(data){
    let bannerSize = data;
    if (bannerSize === 'Full width') {
      this.minWidth = 1400;
      this.maxWidth = 1400;
    }

    if (bannerSize === 'Half width') {
      this.minWidth = 700;
      this.maxWidth = 700;
    }

    if (bannerSize === '1/3 width') {
      this.minWidth = 465;
      this.maxWidth = 465;
    }
  }
  redirectImage(url:any) {
    window.open(url, '_blank');
  }
  getBannerDetail(): void {
    this.authenticationService.getBannerDetail().subscribe(
      (response: any) => {
        this.bannerDetail = response?.data;
         console.log(this.bannerDetail, 'this.bannerDetail')
         if(this.isPlan) this.checkBannerSize(response?.data?.offerBannerSize)
      },
      error => {
        this.spinner.hide();

      }
    );
  }
  onSubmit(): void {


    if (this.bannerForm.invalid) {
      this.bannerForm.markAllAsTouched();
      return;
    }
    console.log(this.address, this.label, 'this.label')
    this.isLocation = true;
    if(this.label !=='Global Visibility'){
      if(this.address == null || this.address == undefined){
        this.isLocation = false;
        return
      }
    }

    if(!this.isValidDimension ) {
      Swal.fire({
        icon: 'error',
        title: "Please Choose Image"
      });
    };
    if(!this.image) {
      Swal.fire({
        icon: 'error',
        title: "Please Choose Valid Image Dimension"
      });
      return;
    }

  if (
    this.planDetail?.caption === 'Regional' &&
    (this.bannerForm.get('radius').value == null || this.bannerForm.get('radius').value === "")
  ) {
    Swal.fire({
      icon: 'error',
      title: 'Please choose a radius for the regional banner plan.',
    });
    return;
  }

    let obj = {
      isDeleted:false,
      image: this.image,
      bannerCategory: this.bannerForm.value.bannerCategory,
      radius: this.bannerForm.value.radius,
      url : this.bannerForm.value.url,
      address: this.address,
      offerLocation: this.bannerDetail ?  this.bannerDetail.offerLocation:  this.planDetail.caption,
      offerBannerSize: this.bannerDetail ?  this.bannerDetail.offerBannerSize: this.planDetail.bannerSize,
    }
    let businessCategory = this.businessCategory.filter(val => val['_id'] == this.bannerForm.value.bannerCategory);
    this.authenticationService.postData('/merchant/banner/add', obj).subscribe(
      (response: any) => {
        let message = ""
        if(this.isPlan) {
          message = "Business Banner saved successfully."
        } else if(this.bannerId){
          message = "Business Banner updated successfully."
        } else {
            message ="You have successfully designed your Business Banner. Please check out to display it."
        }
        Swal.fire("",message, 'success')
        if(this.bannerId || this.isPlan) {
          this.router.navigate(['/banner-ads']);
        } else {
          this.router.navigate(['/base-payment'], { queryParams: { bannerPlanId: this.planDetail._id, category:businessCategory[0].category, isDiscount: this.isDiscount} });
        }


      },
      error => {
        if (error) {
          Swal.fire(
            "Error",
            error.error.message,
            "error"
          );
        }
      }
    );



  }



}
